import React from "react";
import {
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Grid,
  // useMediaQuery,
} from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import multiOIImage from "backgroundImages/MultiOi.png";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function StrikePriceBox() {
  const handleNavigation = (option, path) => {
    localStorage.setItem("page", option);
    window.location.href = path;
  };

  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));

  return (
<Box
      style={{
        backgroundColor: "#dadada",
        padding: "1rem",
        borderRadius: "1rem",
        background: "rgba(218, 218, 218, 0.6)",
        border: "0.1rem solid #dadada",
        backdropFilter: "blur(3px)",
      }}
    >
       <Grid
        container
        style={{
          backgroundColor: "#ffffff",
          padding: "3rem  0.5rem 3rem 0.5rem",
          borderRadius: "1rem",
          border: "0.1rem solid #dadada",
          justifyContent: "space-around",
          display: "flex",
          alignContent: "center",
        }}
      >
      <Grid
          item
          lg={8}
          sm={12}
          display={"inline"}
          justifyContent={"center"}
          textAlign={smDown ? "center" : "left"}
    
        >
              <Box sx={{display:"flex", justifyContent:"center", marginBottom:"2rem", marginTop:"2rem", }}>
            {!smDown ? (
              <img
                src={multiOIImage}
                alt="ChartingHQ logo"
                style={{ height: "50vh", width: "50vw", border:"2px solid #000", borderRadius:"1rem"}}
              />
            ) : (
              <></>
            )}
          </Box>
          </Grid>

        <Grid
          item
          lg={4}
          sm={12}
          display={"inline"}
          justifyContent={"center"}
          textAlign={smDown ? "center" : "right"}
        >
          <Typography
            gutterBottom
            style={{
              color: "#000",
              fontWeight: "600",
              fontSize: "1rem",
              marginBottom: "1rem",
            }}
          >
            Multi Strike Open Interest
          </Typography>

          <Typography
            variant="body1"
            color="rgb(176, 184, 196)"
            fontSize={"0.8rem"}
            paragraph
          >
            See the Bigger Picture With ChartingHQ’s MultiOI page, you can
            analyze Open Interest across multiple strikes in real-time. Stay
            ahead of the curve and make better trading decisions, all from one
            powerful interface
          </Typography>

          <List>
            <ListItem>
              <CheckBoxIcon
                style={{
                  color: "#8E69FD",
                  height: "1rem",
                  marginRight: "0.5rem",
                }}
              />
              <Typography
                variant="body1"
                color="#000"
                fontSize={"0.8rem"}
                paragraph
              >
                Comprehensive OI Analysis: Track Open Interest (OI) data across
                multiple strikes simultaneously, providing you with a clear
                picture of market activity.
              </Typography>

              <ListItemText primary="" />
            </ListItem>

            <ListItem>
              <CheckBoxIcon
                style={{
                  color: "#8E69FD",
                  height: "1rem",
                  marginRight: "0.5rem",
                }}
              />
              <Typography
                variant="body1"
                color="#000"
                fontSize={"0.8rem"}
                paragraph
              >
                Customizable Strike Selection: Choose and compare OI for
                different strikes in one view, helping you to identify key
                support and resistance levels with ease.
              </Typography>
            </ListItem>

            <ListItem>
              <CheckBoxIcon
                style={{
                  color: "#8E69FD",
                  height: "1rem",
                  marginRight: "0.5rem",
                }}
              />
              <Typography
                variant="body1"
                color="#000"
                fontSize={"0.8rem"}
                paragraph
              >
                Dynamic Visualization: View OI data in clear, interactive
                charts, making it easier to spot trends and make informed
                trading decisions.
              </Typography>
            </ListItem>
          </List>

          <Button
            variant="contained"
            style={{
              color: "#fff",
              backgroundColor: "#000",
              fontSize: "0.8rem",
            }}
            mt={2}
            onClick={() => handleNavigation("mo", "/MultiOI")}
          >
            Access MultiOI
          </Button>
        </Grid>
             
      </Grid>
    </Box>
  );
}

export default StrikePriceBox;
